import React from 'react';
import PropTypes from 'prop-types';

import Styled from 'src/components/ButtonTag/ButtonTag.styles';

const ButtonTag = ({ text, crossIconClickHandler, showCrossIcon }) => {
  return (
    <Styled.TagContainer>
      <Styled.TagContainerInner>
        <Styled.TagText>{text}</Styled.TagText>
        {showCrossIcon && <Styled.CloseIcon name="cross" onClick={crossIconClickHandler} />}
      </Styled.TagContainerInner>
    </Styled.TagContainer>
  );
};

ButtonTag.propTypes = {
  crossIconClickHandler: PropTypes.func,
  showCrossIcon: PropTypes.bool,
  text: PropTypes.string
};

ButtonTag.defaultProps = {
  crossIconClickHandler: () => {
  },
  text: '',
  showCrossIcon: true
};

export default ButtonTag;
